var React = require('react');

function Renault (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M111.606 40.0732L109.206 44.5L117.6 60L103.2 86.5732L88.8 60L105.6 29H100.8L84 60L100.8 91H105.6L122.4 60L111.606 40.0732Z","fill":"black","key":0}),React.createElement("path",{"d":"M115.2 29H110.4L93.5996 60L104.406 79.9268L106.806 75.5L98.3996 60L112.8 33.4268L127.2 60L110.4 91H115.2L132 60L115.2 29Z","fill":"black","key":1})]);
}

Renault.defaultProps = {"width":"216","height":"120","viewBox":"0 0 216 120","fill":"none"};

module.exports = Renault;

Renault.default = Renault;
